import React, {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { withLogoHeader } from "app/views/facturation/datatable_facture_tools";
import { Modal } from "react-bootstrap";
import DetailDocument from "app/views/facturation/DetailDocumentComp/DetailDocument";

const ModalFactureVision = (props) => {
    const t = useTranslate();
    const [classModalDocument,setClassModalDocument]=useState("modal-95w")
    const [btnDowloadPdfButtonModal,setBtnDowloadPdfButtonModal]=useState(<div className="spinner-border spinner-border-sm ms-auto"></div>)


    //pour la gestion de la class de la modal de visualisation du document
    useEffect(function (){
        if(props.brownDocumentModal) setClassModalDocument("modal-95w modal-low")//permet de foncé la modal du document si d'autres modal sont ouvertes par dessus
        else setClassModalDocument("modal-95w")
    },[props.brownDocumentModal])
    //end

    const DownloadPdfButton = () => {
        return(<>{btnDowloadPdfButtonModal}</>)//va se mettre à jour grace au comosant enfant qui va mettre le bouton une fois la facture prète
    }

    
    return(
        <Modal dialogClassName={classModalDocument} centered show={props.documentModal} onHide={() => props.closeDocumentModal(false)}>
            <Modal.Header closeButton>
                <div className="d-flex w-100 align-items-center">
                    <Modal.Title>
                        {(props.titleDocument) &&
                            withLogoHeader(
                                props.titleDocument.type,
                                t(props.titleDocument.type) + ' ' + props.titleDocument.bar
                            )
                        }
                    </Modal.Title>

                    <DownloadPdfButton />
                </div>
            </Modal.Header>
            <Modal.Body>
                {(props.selectedDocumentId) &&
                    <DetailDocument id={props.selectedDocumentId} setId={props.setSelectedDocumentId} setTitleDocument={props.setTitleDocument} from={'modal'} setBrownDocumentModal={props.setBrownDocumentModal} setBtnDowloadPdfButtonModal={setBtnDowloadPdfButtonModal}/>
                }
            </Modal.Body>
        </Modal>
    )
}

export default ModalFactureVision;